import type { StationeryProduct } from '@shared/utils/print-price/types';
import { useCallback } from 'react';
import { FOIL_ATTRIBUTE_OPTIONS } from './foilOptions.constants';

type FoilValue = {
  optionId: string;
  colorId: string;
  assetThumbnailUrl: string;
};

const isValidFoil = (input: unknown): input is FoilValue => {
  return !!input;
};

export const useGetFoilConfigs = () => {
  const getFoilConfigs = useCallback((product: StationeryProduct, attributeId: string): FoilValue[] | undefined => {
    const allOptions = product.attributes.find(a => a.attributeId === attributeId)?.attributeOptions;

    return allOptions
      ?.map(dbOption => {
        const feOption = FOIL_ATTRIBUTE_OPTIONS.find(opt => opt.optionId === dbOption.attributeOption.id);
        if (!feOption) return null;

        return {
          colorId: feOption.value,
          assetThumbnailUrl: feOption.assetThumbnailUrl,
          optionId: dbOption.attributeOption.id,
        };
      })
      .filter(isValidFoil);
  }, []);

  return { getFoilConfigs };
};
